const getOfferShareUrl = (offer) => {
  if (!offer) return null;

  return offer.shareUrl;
};

export default getOfferShareUrl;
